/* so-fbt.js — "Frequently bought together".
   Complementary recommendations inject async into <product-recommendations>.innerHTML
   (scripts there don't run — this file loads on the initial PDP render and watches for the
   injection). Builds per-row variant controls (chips ≤5 / the shared so-variant-drawer look
   for >5 / a stacked sheet for multi-axis), resolves a variant id, tracks a live total, and
   (Task 5) batch-adds to the cart. */
(function () {
  'use strict';

  // F2: one stock vocabulary (assets/so-stock-state.js, loaded in <head>).
  function soPreShip() { var s = window.SO && SO.stock ? SO.stock.shipText('pre', null, null, true) : ''; return s ? ' · ' + s : ''; }
  function soRowTag(qty, policy, notify, unit) {
    if (!(window.SO && SO.stock)) return qty > 0 ? 'In stock' : (policy === 'continue' ? 'Pre-order' : 'Out of stock');
    return SO.stock.label(SO.stock.classify({ tracked: true, policy: policy, qty: qty }, SO.stock.lowAt()), 'row', { notify: !!notify, unit: unit });
  }

  // P0-2B: ONE money format across the module — the buy button's (so-preorder-pdp formatRand):
  // "R199", "R1,190", "R95.20". The local copy is only a fallback if that script isn't loaded.
  function money(cents) {
    if (cents == null) return '';
    var P = window.customElements && customElements.get('so-preorder-pdp');
    if (P && P.formatRand) return P.formatRand(cents);
    var d = Math.round(cents) % 100 === 0 ? 0 : 2;
    return 'R' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  var X_SVG = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  // ---- variant resolution + availability -------------------------------------------------
  function variantsMatching(data, selected) {
    return data.variants.filter(function (v) {
      return data.options.every(function (o, i) { var val = selected[o.name]; return val == null || v.options[i] === val; });
    });
  }
  function resolve(data, selected) {
    var complete = data.options.every(function (o) { return selected[o.name] != null; });
    return complete ? (variantsMatching(data, selected)[0] || null) : null;
  }
  function valueAvailable(data, axisIndex, value, selected) {
    var sel = {};
    data.options.forEach(function (o, i) { if (i !== axisIndex) sel[o.name] = selected[o.name]; });
    sel[data.options[axisIndex].name] = value;
    return variantsMatching(data, sel).some(function (v) { return v.available; });
  }
  // P0-2B: an untracked variant (tracked:false) is always buyable, never a pre-order.
  function isPreorder(v) { return v && v.available && v.tracked !== false && v.policy === 'continue' && (v.qty == null || v.qty <= 0); }
  // For a single-axis product, map each value → {img, available, preorder}
  function valueMetaSingleAxis(data) {
    var meta = {};
    data.options[0].values.forEach(function (val) {
      var vs = data.variants.filter(function (v) { return v.options[0] === val; });
      var av = vs.find(function (v) { return v.available; }) || vs[0];
      meta[val] = { img: (vs.find(function (v) { return v.image; }) || {}).image || data.image, available: !!(av && av.available), preorder: isPreorder(av) };
    });
    return meta;
  }

  // ---- shared right-side drawer (matches the PDP so-variant-drawer look) ------------------
  function makeDrawerController() {
    var backdrop, drawer, listEl, searchEl, titleEl, noRes, onPick = null, curData = null;
    function build() {
      backdrop = el('div', 'so-vd__backdrop so-fbt-vd'); backdrop.hidden = true;
      drawer = el('div', 'so-vd__drawer so-fbt-vd'); drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true'); drawer.tabIndex = -1; drawer.hidden = true;
      drawer.innerHTML =
        '<header class="so-vd__header"><h2 class="so-vd__title" data-title></h2>'
        + '<button type="button" class="so-vd__close" data-close aria-label="Close">' + X_SVG + '</button></header>'
        + '<div class="so-vd__search-wrap"><input type="search" class="so-vd__search" data-search placeholder="Search…" autocomplete="off"></div>'
        + '<ul class="so-vd__list" data-list role="listbox"></ul>'
        + '<p class="so-vd__noresults" data-nores hidden>No matches — try another search.</p>';
      document.body.appendChild(drawer); document.body.appendChild(backdrop);
      listEl = drawer.querySelector('[data-list]'); searchEl = drawer.querySelector('[data-search]');
      titleEl = drawer.querySelector('[data-title]'); noRes = drawer.querySelector('[data-nores]');
      backdrop.addEventListener('click', close);
      drawer.querySelector('[data-close]').addEventListener('click', close);
      searchEl.addEventListener('input', filter);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
    }
    function filter() {
      var q = searchEl.value.trim().toLowerCase(), any = false;
      Array.prototype.forEach.call(listEl.children, function (row) {
        var m = row.getAttribute('data-value').toLowerCase().indexOf(q) !== -1;
        row.hidden = !m; if (m) any = true;
      });
      noRes.hidden = any;
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open'); backdrop.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; backdrop.hidden = true; }, 260);
    }
    function open(data, model, done) {
      if (!drawer) build();
      curData = data; onPick = done;
      var opt = data.options[0], meta = valueMetaSingleAxis(data), selVal = model.selected[opt.name];
      titleEl.textContent = 'Choose your ' + opt.name.toLowerCase();
      searchEl.placeholder = 'Search ' + opt.name.toLowerCase() + '…';
      searchEl.value = '';
      listEl.innerHTML = '';
      opt.values.forEach(function (val) {
        var m = meta[val];
        var row = el('li', 'so-vd__row'); row.setAttribute('data-value', val); row.setAttribute('role', 'option'); row.tabIndex = 0;
        if (!m.available && !m.preorder) row.classList.add('is-unavailable');
        if (val === selVal) row.classList.add('is-selected');
        var thumb = el('span', 'so-vd__thumb');
        if (m.img) { var img = new Image(); img.src = m.img; img.alt = ''; img.loading = 'lazy'; img.width = 48; img.height = 48; thumb.appendChild(img); }
        else thumb.appendChild(el('span', 'so-vd__thumb-fallback'));
        var text = el('span', 'so-vd__row-text');
        var name = el('span', 'so-vd__row-name'); name.textContent = val; text.appendChild(name);
        var tag = el('span', 'so-vd__row-tag');
        if (m.preorder) { tag.textContent = 'Pre-order' + soPreShip(); } else if (!m.available) { tag.textContent = soRowTag(0, 'deny', false, data.unit); } else { tag.hidden = true; }
        text.appendChild(tag);
        row.appendChild(thumb); row.appendChild(text); row.appendChild(el('span', 'so-vd__row-check'));
        function choose() { if (row.classList.contains('is-unavailable')) return; model.selected[opt.name] = val; onPick(); close(); }
        row.addEventListener('click', choose);
        row.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); } });
        listEl.appendChild(row);
      });
      noRes.hidden = true;
      backdrop.hidden = false; drawer.hidden = false;
      void drawer.offsetWidth;
      backdrop.classList.add('is-open'); drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      // Phones: swipe down to close (shared assets/so-sheet-swipe.js; the ::before grab bar is the affordance).
      if (window.soSheetSwipe) window.soSheetSwipe.attach(drawer, { handle: '.so-vd__header', scroller: '.so-vd__list', backdrop: backdrop, onClose: close });
      drawer.focus();
    }
    return { open: open };
  }

  // ---- stacked sheet for multi-axis products (rare; not currently surfaced) ---------------
  function makeSheetController() {
    var refs = null, onDone = null;
    function build() {
      var scrim = el('div', 'so-fbt-scrim'); scrim.hidden = true;
      var sheet = el('div', 'so-fbt-sheet'); sheet.hidden = true;
      sheet.innerHTML = '<div class="so-fbt-sheet__head"><h3 class="so-fbt-sheet__title" data-title></h3>'
        + '<button type="button" class="so-fbt-sheet__close" data-close aria-label="Close">&times;</button></div>'
        + '<div class="so-fbt-sheet__body" data-body></div>'
        + '<div class="so-fbt-sheet__foot"><button type="button" class="so-fbt-sheet__add" data-add disabled>Add to order</button></div>';
      document.body.appendChild(scrim); document.body.appendChild(sheet);
      refs = { scrim: scrim, sheet: sheet };
      scrim.addEventListener('click', close);
      sheet.querySelector('[data-close]').addEventListener('click', close);
      sheet.querySelector('[data-add]').addEventListener('click', function () { if (onDone) onDone(); close(); });
    }
    function close() {
      if (!refs) return;
      refs.scrim.classList.remove('is-open'); refs.sheet.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { refs.scrim.hidden = true; refs.sheet.hidden = true; }, 240);
    }
    function open(data, model, done) {
      if (!refs) build();
      onDone = done;
      var body = refs.sheet.querySelector('[data-body]'), addBtn = refs.sheet.querySelector('[data-add]');
      refs.sheet.querySelector('[data-title]').textContent = data.title;
      body.innerHTML = '';
      function refreshAll() {
        Array.prototype.forEach.call(body.querySelectorAll('[data-axis]'), function (group) {
          var ai = +group.getAttribute('data-axis');
          Array.prototype.forEach.call(group.querySelectorAll('[data-val]'), function (o) {
            var v = o.getAttribute('data-val'), avail = valueAvailable(data, ai, v, model.selected);
            o.classList.toggle('is-unavailable', !avail);
            o.classList.toggle('is-on', model.selected[data.options[ai].name] === v);
            o.disabled = !avail;
          });
        });
        var complete = data.options.every(function (o) { return model.selected[o.name] != null; });
        var variant = complete ? resolve(data, model.selected) : null;
        addBtn.disabled = !(variant && variant.available);
      }
      data.options.forEach(function (opt, ai) {
        var group = el('div', 'so-fbt-sheet__axis'); group.setAttribute('data-axis', ai);
        var axl = el('p', 'so-fbt-sheet__axislbl'); axl.textContent = opt.name; group.appendChild(axl);
        var list = el('div', 'so-fbt-chips');
        opt.values.forEach(function (val) {
          var item = el('button', 'so-fbt-chip'); item.type = 'button'; item.setAttribute('data-val', val); item.textContent = val;
          item.addEventListener('click', function () { if (item.disabled) return; model.selected[opt.name] = val; refreshAll(); });
          list.appendChild(item);
        });
        group.appendChild(list); body.appendChild(group);
      });
      refreshAll();
      refs.scrim.hidden = false; refs.sheet.hidden = false;
      void refs.sheet.offsetWidth;
      refs.scrim.classList.add('is-open'); refs.sheet.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    return { open: open };
  }

  // ---- per-card setup --------------------------------------------------------------------
  function setupCard(card, ctx) {
    var data = card._soData;
    var checkEl = card.querySelector('[data-so-fbt-check]');
    var optsEl = card.querySelector('[data-so-fbt-opts]');
    var priceEl = card.querySelector('[data-so-fbt-price]');
    var single = data.has_only_default_variant || data.variants.length === 1;
    var soldOut = !data.variants.some(function (v) { return v.available; });
    var model = card._fbt = { data: data, selected: {}, variant: single ? data.variants[0] : null, included: false,
      control: single ? 'single' : null };

    function renderPrice() {
      var v = model.variant, priceCents = v ? v.price : data.price, cmp = v ? v.compare_at : null;
      var html = '<span class="so-fbt-card__now">' + ((!v && data.price_varies) ? 'From ' : '') + money(priceCents) + '</span>';
      if (cmp && cmp > priceCents) html += '<span class="so-fbt-card__was">' + money(cmp) + '</span><span class="so-fbt-card__save so-pill">Save ' + money(cmp - priceCents) + '</span>';
      if (isPreorder(v)) html += '<span class="so-fbt-card__po so-pill">Pre-order</span>';
      priceEl.innerHTML = html;
    }
    function setIncluded(on) {
      model.included = on && !!model.variant && model.variant.available;
      checkEl.classList.toggle('is-on', model.included);
      checkEl.setAttribute('aria-checked', model.included ? 'true' : 'false');
      card.classList.toggle('is-included', model.included);
      ctx.recalc();
    }
    function onResolved() {
      model.variant = resolve(data, model.selected);
      renderPrice(); refreshChips(); updateChooseLabel();
      var ok = !!(model.variant && model.variant.available);
      setIncluded(ok);
      if (ok) card.classList.add('is-expanded'); // keep the chosen option visible
    }

    var singleAxisSmall = data.options.length === 1 && data.options[0].values.length <= 5;
    var singleAxisMany = data.options.length === 1 && data.options[0].values.length > 5;
    var multiAxis = data.options.length > 1;
    var trig = null;

    function refreshChips() {
      if (!singleAxisSmall) return;
      Array.prototype.forEach.call(optsEl.querySelectorAll('.so-fbt-chip'), function (chip) {
        var val = chip.getAttribute('data-val'), avail = valueAvailable(data, 0, val, model.selected);
        chip.classList.toggle('is-unavailable', !avail);
        chip.classList.toggle('is-on', model.selected[data.options[0].name] === val);
        chip.disabled = !avail;
      });
    }
    function updateChooseLabel() {
      if (!trig) return;
      var lab = trig.querySelector('[data-choose-label]');
      var chosen = data.options.map(function (o) { return model.selected[o.name]; }).filter(Boolean);
      lab.textContent = chosen.length ? chosen.join(' · ') : defaultChooseLabel();
      trig.classList.toggle('is-set', chosen.length === data.options.length);
    }
    function defaultChooseLabel() { return singleAxisMany ? ('Choose your ' + data.options[0].name.toLowerCase()) : 'Choose options'; }

    if (soldOut) {
      card.classList.add('is-soldout');
      optsEl.innerHTML = '<span class="so-fbt-card__oos">' + soRowTag(0, 'deny', false) + '</span>';
      checkEl.setAttribute('aria-disabled', 'true');
      renderPrice(); return model;
    }

    model.control = single ? 'single' : (singleAxisSmall ? 'chips' : (singleAxisMany ? 'drawer' : 'sheet'));
    if (single) {
      renderPrice();
    } else if (singleAxisSmall) {
      var opt = data.options[0];
      var lbl = el('p', 'so-fbt-card__optlbl'); lbl.textContent = opt.name + ' · ' + opt.values.length + ' options';
      var wrap = el('div', 'so-fbt-chips');
      opt.values.forEach(function (val) {
        var chip = el('button', 'so-fbt-chip'); chip.type = 'button'; chip.textContent = val; chip.setAttribute('data-val', val);
        chip.addEventListener('click', function () { if (chip.disabled) return; model.selected[opt.name] = val; onResolved(); });
        wrap.appendChild(chip);
      });
      optsEl.appendChild(lbl); optsEl.appendChild(wrap); refreshChips(); renderPrice();
    } else {
      trig = el('button', 'so-fbt-card__choose'); trig.type = 'button';
      trig.innerHTML = '<span data-choose-label></span><span aria-hidden="true">›</span>';
      var opener = singleAxisMany ? ctx.openDrawer : ctx.openSheet;
      trig.addEventListener('click', function () { opener(data, model, onResolved); });
      optsEl.appendChild(trig); updateChooseLabel(); renderPrice();
    }

    model.reset = function () {
      if (soldOut) return;
      model.selected = {};
      model.variant = single ? data.variants[0] : null;
      setIncluded(false);
      renderPrice(); refreshChips(); updateChooseLabel();
    };

    checkEl.addEventListener('click', toggle);
    checkEl.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); } });
    function toggle() {
      if (soldOut) return;
      if (single) { setIncluded(!model.included); return; }
      if (model.included) { setIncluded(false); card.classList.remove('is-expanded'); return; } // untick → collapse
      // ticking an unconfigured item reveals its options: chips expand inline, drawer/sheet open directly
      if (singleAxisSmall) { card.classList.toggle('is-expanded'); }
      else (singleAxisMany ? ctx.openDrawer : ctx.openSheet)(data, model, onResolved);
    }
    return model;
  }

  // ---- module init -----------------------------------------------------------------------
  function init(root) {
    if (root.dataset.soFbtReady) return;
    root.dataset.soFbtReady = '1';
    Array.prototype.forEach.call(root.querySelectorAll('[data-so-fbt-card]'), function (card) {
      var s = card.querySelector('.so-fbt-card__data');
      if (!s) return;
      try { card._soData = JSON.parse(s.textContent); } catch (e) { }
    });

    var countEl = root.querySelector('[data-so-fbt-count]');
    var totalEl = root.querySelector('[data-so-fbt-total]');
    var addBtn = root.querySelector('[data-so-fbt-add]');
    // P0-2B: a bundle-only module (every complement is in the bundle) has no rows or footer.
    if (!addBtn || !countEl || !totalEl) return;
    var addTxt = root.querySelector('[data-so-fbt-addtxt]');
    var errEl = root.querySelector('[data-so-fbt-err]');
    var drawer = makeDrawerController(), sheet = makeSheetController();

    // ---- P0-2B: the main product (Amazon "Frequently bought together" pattern) -----------------
    // The main buy box's so-preorder-pdp owns "what the main button adds" (buyState(): variant,
    // price, effective pack-aware qty). FBT reads it — never a second copy of the pack rules — and
    // re-totals on its `so:buy-state` event (variant / qty change, after add). While the main product
    // is addable, the total and the button include it and one /cart/add.js call adds it first.
    // Otherwise (sold out / not selected) FBT is add-ons only.
    var mainRow = root.querySelector('[data-so-fbt-main]');
    var mainName = root.querySelector('[data-so-fbt-main-name]');
    var mainQty = root.querySelector('[data-so-fbt-main-qty]');
    var mainPrice = root.querySelector('[data-so-fbt-main-price]');
    var mainCheck = root.querySelector('[data-so-fbt-main-check]');
    var totRow = root.querySelector('[data-so-fbt-totrow]');
    // Single-variant products have no variant name ("Default Title"): fall back to the product's
    // custom.short_name / title, emitted by so-fbt.liquid.
    var mainFallbackName = mainRow ? (mainRow.getAttribute('data-main-name') || '') : '';
    // Amazon-style tick on "This item", ticked by default. After the MAIN button (or the sticky bar,
    // which submits the same form) adds this product, `lastMainAdd` records {id, qty} and the row is
    // unticked, so FBT can't add it a second time; the customer may re-tick. Any change to the main
    // variant or quantity clears the record and re-ticks.
    var wantMain = true, lastMainAdd = null;
    function mainPdp() {
      var scope = root.closest('.js-product, .shopify-section');
      var el = scope && scope.querySelector('so-preorder-pdp');
      if (el && !el.closest('quick-add-drawer')) return el;
      return Array.prototype.filter.call(document.querySelectorAll('so-preorder-pdp'), function (x) { return !x.closest('quick-add-drawer'); })[0] || null;
    }
    function mainState() {
      var el = mainPdp();
      if (!el || typeof el.buyState !== 'function') return null;
      try { var st = el.buyState(); return st && st.addable ? st : null; } catch (e) { return null; }
    }
    var fmt = money;
    // Everything the main form itself would send besides id/quantity (line-item properties from
    // custom-option blocks, selling plan), so a main line added here is identical to the main button's.
    function mainExtras(form) {
      var out = {};
      if (!form || !window.FormData) return out;
      new FormData(form).forEach(function (val, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (m && typeof val === 'string' && val !== '') { out.properties = out.properties || {}; out.properties[m[1]] = val; }
        // selling_plan is deliberately NOT copied: the FBT total is priced at the one-off variant
        // price, so a subscription line added here would not match the total shown.
      });
      return out;
    }

    // A full-pack pre-order adds a whole pack, so it is priced as one too.
    function packQty(v) { return (isPreorder(v) && v.full_pack && v.pack_size > 1) ? v.pack_size : 1; }

    var models = [];
    var holdTxt = false; // keep "Added to cart" visible for a moment after a successful add
    var ctx = {
      openDrawer: drawer.open, openSheet: sheet.open,
      recalc: function () {
        var addOnTotal = 0, addOns = 0;
        models.forEach(function (m) { if (m.included && m.variant) { addOnTotal += m.variant.price * packQty(m.variant); addOns++; } });
        var st = mainState();
        // A different variant/qty than the one the main button just added (or nothing addable any
        // more) clears the record and re-ticks the main row.
        if (lastMainAdd && (!st || st.id !== lastMainAdd.id || st.qty !== lastMainAdd.qty)) { lastMainAdd = null; wantMain = true; }
        var mainOn = !!st && wantMain;
        var mainCents = mainOn ? st.price * st.qty : 0;
        if (mainRow) {
          mainRow.hidden = !st;
          if (st) {
            var vt = st.title && st.title.indexOf('Default') !== 0 ? st.title : mainFallbackName;
            if (mainQty) mainQty.textContent = ' × ' + st.qty;
            mainName.textContent = vt ? '\u00a0· ' + vt : ''; // nbsp: a leading space is stripped in the flex row
            mainPrice.textContent = fmt(st.price * st.qty);
            mainRow.classList.toggle('is-included', mainOn);
            if (mainCheck) {
              mainCheck.classList.toggle('is-on', mainOn);
              mainCheck.setAttribute('aria-checked', mainOn ? 'true' : 'false');
              mainCheck.setAttribute('aria-label', 'This item' + (vt ? ': ' + vt : '') + ' × ' + st.qty);
            }
          }
        }
        var count = addOns + (mainOn ? 1 : 0);
        var total = addOnTotal + mainCents; // always exactly the ticked lines = the add payload
        countEl.textContent = count + (count === 1 ? ' item' : ' items');
        // No total beside a dead button: the count + total only show once an add-on is ticked,
        // and then they are exactly the ticked lines (main included when ticked).
        totalEl.textContent = addOns ? fmt(total) : '—';
        if (totRow) totRow.hidden = addOns === 0;
        if (holdTxt) return;
        // The main button already covers "just this item": FBT only acts once an add-on is ticked.
        addBtn.disabled = addOns === 0;
        if (!addTxt) return;
        if (addOns === 0) addTxt.textContent = 'Tick an add-on to add it';
        else if (mainOn) addTxt.textContent = (count === 2 ? 'Add both to cart' : 'Add all ' + count + ' to cart') + ' · ' + fmt(total);
        else addTxt.textContent = 'Add ' + addOns + (addOns === 1 ? ' add-on' : ' add-ons') + ' · ' + fmt(total);
      }
    };
    Array.prototype.forEach.call(root.querySelectorAll('[data-so-fbt-card]'), function (card) {
      if (card._soData) models.push(setupCard(card, ctx));
    });
    root._soFbtModels = models;
    ctx.recalc();
    // Follow the main buy box live. One listener per module; it removes itself once this module is
    // replaced (the recommendations block can be re-injected).
    function onBuyState(e) {
      if (!root.isConnected) { document.removeEventListener('so:buy-state', onBuyState); return; }
      if (e.target === mainPdp()) ctx.recalc();
    }
    document.addEventListener('so:buy-state', onBuyState);

    if (mainCheck) {
      var toggleMain = function () { wantMain = !wantMain; ctx.recalc(); };
      mainCheck.addEventListener('click', toggleMain);
      mainCheck.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggleMain(); } });
    }
    // The main <product-form> fires on:cart:add (new line) / on:line-item:change (existing line) after
    // a successful add — for its own button AND the sticky bar (which submits the same form).
    function markMainAdded(id, qty) { lastMainAdd = { id: id, qty: qty }; wantMain = false; ctx.recalc(); }
    var mainPf = (function () { var el = mainPdp(); return el ? el.closest('product-form') : null; })();
    function onMainAdded(e) {
      if (!root.isConnected) { ['on:cart:add', 'on:line-item:change'].forEach(function (ev) { mainPf.removeEventListener(ev, onMainAdded); }); return; }
      var st = mainState();
      var vid = e.detail && Number(e.detail.variantId);
      if (st && vid === st.id) markMainAdded(st.id, st.qty);
    }
    if (mainPf) ['on:cart:add', 'on:line-item:change'].forEach(function (ev) { mainPf.addEventListener(ev, onMainAdded); });

    // Batched add → cart drawer, using the theme's own pattern (product-form.js): request the
    // cart-drawer + icon sections in the add call, then renderContents(response) which renders AND
    // opens. (A bare refresh() races when the cart starts empty — no <cart-items> to refresh.)
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled || addBtn.dataset.busy) return;
      var items = [];
      models.forEach(function (m) { if (m.included && m.variant) items.push({ id: m.variant.id, quantity: packQty(m.variant) }); });
      if (!items.length) return;
      // P0-2B: the main product goes first, with the same qty and extras the main button would send.
      var st = mainState();
      var mainIncluded = !!st && wantMain;
      if (mainIncluded) {
        var mainItem = { id: st.id, quantity: st.qty };
        var extras = mainExtras(st.form);
        if (extras.properties) mainItem.properties = extras.properties;
        items.unshift(mainItem);
      }

      var cd = document.querySelector('cart-drawer');
      var sections = 'cart-icon-bubble';
      if (cd && cd.closest('.shopify-section')) sections += ',' + cd.closest('.shopify-section').id.replace('shopify-section-', '');
      var succeeded = false;

      addBtn.dataset.busy = '1'; addBtn.disabled = true;
      var prevTxt = addTxt ? addTxt.textContent : '';
      if (addTxt) addTxt.textContent = 'Adding…';
      holdTxt = true;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
      })
        .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
        .then(function (r) {
          if (!r.ok) throw (r.body && (r.body.description || r.body.message)) || 'Could not add to cart.';
          // The main line went in with this request: record it like a main-button add (unticks it).
          if (mainIncluded) { lastMainAdd = { id: st.id, qty: st.qty }; wantMain = false; }
          models.forEach(function (m) { if (m.reset) m.reset(); });
          // P0-2B: refresh (icon bubble + drawer contents) and open the drawer exactly like the main
          // add-to-cart does (product-form.js opens it when theme.settings.afterAtc === 'drawer').
          var openDrawer = !!(window.theme && theme.settings && theme.settings.afterAtc === 'drawer');
          if (cd && cd.renderContents && r.body.sections) { cd.renderContents(r.body, openDrawer); }
          else if (r.body.sections && r.body.sections['cart-icon-bubble']) {
            var bub = document.getElementById('cart-icon-bubble');
            if (bub) { var tmp = document.createElement('template'); tmp.innerHTML = r.body.sections['cart-icon-bubble']; var inner = tmp.content.querySelector('.shopify-section'); bub.innerHTML = inner ? inner.innerHTML : bub.innerHTML; }
          }
          succeeded = true;
        })
        .catch(function (err) {
          // Shopify rejects the whole items[] request if any line fails (e.g. stock). Show its reason;
          // when the main line was part of it, tell the customer how to add just the add-ons. No retry.
          if (errEl) {
            errEl.hidden = false;
            errEl.textContent = (typeof err === 'string' ? err : 'Something went wrong — please try again.')
              + (mainIncluded ? ' Untick "This item" to add just the add-ons.' : '');
          }
        })
        .then(function () {
          addBtn.dataset.busy = '';
          if (succeeded) {
            if (addTxt) addTxt.textContent = 'Added to cart';   // button confirmation
            addBtn.disabled = true;
            setTimeout(function () { holdTxt = false; ctx.recalc(); }, 1900); // reverts to "Tick an add-on to add it"
          } else {
            holdTxt = false;
            if (addTxt) addTxt.textContent = prevTxt; ctx.recalc();
          }
        });
    });

    if (window.console) console.log('[so-fbt] controls ready:', models.length);
  }

  function watch(rec) {
    // Stay connected: the theme's ProductRecommendations.init can run more than once (retries,
    // repeated intersections), re-injecting the module. init() is idempotent per module element
    // (guarded by data-so-fbt-ready), so re-checking on every mutation is safe and ensures a
    // freshly-injected module always gets wired.
    var tryInit = function () { var m = rec.querySelector('[data-so-fbt]'); if (m) init(m); };
    tryInit();
    new MutationObserver(tryInit).observe(rec, { childList: true, subtree: true });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('product-recommendations'), watch); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
